import { useEffect, useRef, useState } from "react";
import { Send, User } from "lucide-react";
import { api } from "@/lib/api";
import { SourceBadge } from "@/components/SourceBadge";

const SUGGESTIONS = ["Oi, boa noite", "Quero um teste grátis", "Qual o valor do plano?", "Como instalar na Smart TV?"];

const Bubble = ({ m, i }) => (
  <div className={`flex ${m.me ? "justify-end" : "justify-start"} msg-in`} data-testid={`sim-msg-${i}`}>
    <div className={`bubble ${m.me ? "bubble-me" : "bubble-bot"}`}>
      {!m.me && m.source && <div className="mb-1"><SourceBadge source={m.source} testId={`sim-msg-source-${i}`} /></div>}
      <p className="whitespace-pre-wrap text-sm">{m.text}</p>
    </div>
  </div>
);

export const Simulator = ({ settings }) => {
  const [sender, setSender] = useState("Cliente Teste");
  const [text, setText] = useState("");
  const [msgs, setMsgs] = useState([]);
  const [busy, setBusy] = useState(false);
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, busy]);

  const send = async (message) => {
    if (!message.trim() || busy) return;
    setText(""); setBusy(true);
    setMsgs((p) => [...p, { me: true, text: message }]);
    try {
      const { data } = await api.post("/simulate", { sender, message });
      const replies = data.replies.length ? data.replies : [data.error || "(sem resposta)"];
      setMsgs((p) => [...p, ...replies.map((r) => ({ me: false, text: r, source: data.source }))]);
    } catch { setMsgs((p) => [...p, { me: false, text: "Erro ao conectar ao servidor", source: "error" }]); }
    setBusy(false);
  };

  return (
    <div className="grid lg:grid-cols-[1fr_380px] gap-6 items-start">
      <div className="phone" data-testid="simulator-phone">
        <div className="wa-header">
          <div className="w-9 h-9 rounded-full bg-[#10B981]/20 flex items-center justify-center"><User className="w-4 h-4 text-[#25D366]" /></div>
          <div><p className="text-sm font-semibold">{settings?.bot_name || "Assistente"}</p><p className="text-[11px] text-[#9CA3AF]">{busy ? "digitando..." : "online"}</p></div>
        </div>
        <div className="wa-body" data-testid="simulator-messages">
          {msgs.length === 0 && <p className="text-center text-xs text-[#9CA3AF] mt-10">Envie uma mensagem como se fosse um cliente.</p>}
          {msgs.map((m, i) => <Bubble key={i} m={m} i={i} />)}
          {busy && <div className="bubble bubble-bot typing" data-testid="simulator-typing"><span /><span /><span /></div>}
          <div ref={end} />
        </div>
        <form className="wa-input" onSubmit={(e) => { e.preventDefault(); send(text); }}>
          <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Mensagem" className="flex-1 bg-[#1F2937] rounded-full px-4 h-11 text-sm outline-none focus:ring-2 focus:ring-[#10B981]" data-testid="simulator-input" />
          <button type="submit" disabled={busy} className="send-btn" data-testid="simulator-send-button"><Send className="w-4 h-4" /></button>
        </form>
      </div>
      <aside className="panel-card space-y-5">
        <div className="space-y-2">
          <label className="text-sm font-medium">Nome do contato simulado</label>
          <input value={sender} onChange={(e) => setSender(e.target.value)} className="w-full input-dark h-11 rounded-md px-3 text-sm border" data-testid="simulator-sender-input" />
          <p className="text-xs text-[#6B7280]">O histórico da IA é separado por contato.</p>
        </div>
        <div className="space-y-2">
          <p className="text-sm font-medium">Sugestões rápidas</p>
          <div className="flex flex-wrap gap-2">
            {SUGGESTIONS.map((s, i) => <button key={s} onClick={() => send(s)} className="chip" data-testid={`simulator-suggestion-${i}`}>{s}</button>)}
          </div>
        </div>
        <p className="text-xs text-[#9CA3AF] leading-relaxed">Atenção: o simulador usa o painel real. Pedir um teste aqui pode gerar um teste de verdade no seu painel.</p>
        <button onClick={() => setMsgs([])} className="chip" data-testid="simulator-clear-button">Limpar conversa</button>
      </aside>
    </div>
  );
};
